import React, { useMemo } from "react";
import { Card, CardContent, CardFooter } from "@/components/ui/card";

import { ChatAppResponse } from "@/api";
import { parseAnswerToHtml } from "./AnswerParser";

interface Props {
    answer: ChatAppResponse;
    isSelected?: boolean;
    isStreaming: boolean;
    onCitationClicked: (filePath: string) => void;
    onFollowupQuestionClicked?: (question: string) => void;
    showFollowupQuestions?: boolean;
}

export const Answer = ({ answer, isSelected, isStreaming, onCitationClicked, onFollowupQuestionClicked, showFollowupQuestions }: Props) => {
    const followupQuestions = answer.choices[0].context.followup_questions;
    const messageContent = answer.choices[0].message.content;
    const parsedAnswer = useMemo(() => parseAnswerToHtml(messageContent, isStreaming, onCitationClicked), [answer, isStreaming, onCitationClicked]);

    return (
        <Card className={`w-full ${isSelected ? "border-2 border-blue-500" : ""}`}>
            <CardContent className="pt-4">
                <div className="whitespace-pre-line">{parsedAnswer.answerFragments}</div>
            </CardContent>

            {!!parsedAnswer.citations.length && (
                <CardFooter>
                    <div className="flex flex-wrap gap-1">
                        <span className="font-medium">Citations:</span>
                        {parsedAnswer.citations.map((part, index) => {
                            const path = part;
                            return (
                                <a
                                    key={index}
                                    className="cursor-pointer rounded bg-blue-100 px-1 font-light text-blue-800 hover:underline"
                                    title={part}
                                    target="_blank"
                                    onClick={() => onCitationClicked(path)}
                                >
                                    {`${index + 1}. ${part}`}
                                </a>
                            );
                        })}
                    </div>
                </CardFooter>
            )}

            {!!followupQuestions?.length && showFollowupQuestions && onFollowupQuestionClicked && (
                <CardFooter>
                    <div className="flex flex-wrap gap-1">
                        <span className="font-medium">Follow-up questions:</span>
                        {followupQuestions.map((x, i) => {
                            return (
                                <a
                                    key={i}
                                    className="cursor-pointer rounded bg-gray-200 px-1 font-light italic hover:underline"
                                    title={x}
                                    onClick={() => onFollowupQuestionClicked(x)}
                                >
                                    {x}
                                </a>
                            );
                        })}
                    </div>
                </CardFooter>
            )}
        </Card>
    );
};
